import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Spinner, Button, Container, Modal, Alert} from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { api } from '../services/Api';
import { formatDate } from '../Utils/formatDate';
import {useHistory} from "react-router-dom";
import {useAlert} from "../contexts/AlertContext";
import {useAuth} from "../contexts/AuthenticationContext";

type ContractDetailsType = {
    scm: number;
    scm_exclusivo: number;
    stfc: number;
};

type StreamingType = [{
	id_contrato_servico: number | null;
	id_contrato_servico_produto: number | null;
	nome: string;
	servicos: [];
}]

type ContractType = {
	id: number;
	bairro: string;
	cidade: string;
	data: string;
	desbloqueio: string;
	download_ativa: string;
	endereco: string;
	endereco_numero: number;
	id_anexo_download_contrato: number;
	ids_anexo_download_contrato: [];
	id_contrato: number;
	id_tipo_conexao: number;
	link_assinatura: string;
	links_assinatura: [];
	numero_contrato: string;
	pendente_de_assinatura: boolean;
	plano: string;
	preco: string;
	status: string;
	upload_ativa: string;
	streamings: StreamingType | null;
	playhub: boolean;
}
export function Contract() {
	const history = useHistory();

	const { handleSetAlert } = useAlert();
	const { session } = useAuth();

	const [contract, setContract] = useState<ContractType | null>(null);
	const [unblockResponse, setUnblockResponse] = useState<String>('');
	const [unblockResponseStatus, setUnblockResponseStatus] = useState<boolean | null>(true);
	const [unblockResponseReload, setUnblockResponseReload] = useState<boolean | null>(false);
	const [showModalUnblock, setShowModalUnblock] = useState(false);
	const [loadingModalUnblock, setLoadingModalUnblock] = useState(false);
	const [loadingContract, setLoadingContract] = useState(false);
	const [contractDetails, setContractDetails] = useState<ContractDetailsType>({ scm: 0, scm_exclusivo: 0, stfc: 0 });

	useEffect(() => {
		if(session){
			setLoadingContract(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/contratos/'+session.id_contract, { headers })
				.then((response) => {
					setContract(response.data);
					setLoadingContract(false);
					setContractDetails({
							scm: response.data.scm,
							scm_exclusivo: response.data.scm_exclusivo,
							stfc: response.data.stfc
					});
				})
				.catch(error => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
					history.goBack();
					setLoadingContract(false);
				});
		}
	}, [session, history, handleSetAlert])


	function handleContractUnblock() {
		if(session){
			setLoadingModalUnblock(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.post('v1/pessoas/clientes/desbloqueio-temporario', JSON.stringify({id: contract?.id}), { headers })
				.then((response) => {
					setUnblockResponse(response.data.message)
					setUnblockResponseStatus(true);
					setLoadingModalUnblock(false);
					setUnblockResponseReload(true);
				})
				.catch(error => {
					setUnblockResponse(error.response.data.message);
					setUnblockResponseStatus(false);
					setLoadingModalUnblock(false);
					setUnblockResponseReload(false);
				});
		}
	}

	function handleContractTerms(contractDownloadId: number) {
		if(session){
			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/contratos/anexo/' + contractDownloadId, {headers})
				.then((response) => {
					const data = `data:application/pdf;base64,${response.data.anexo}`;
					let link = window.document.createElement('a');
					link.href = data;
					link.download = "Termo_de_Adesao_" + contractDownloadId + ".pdf";
					link.click();
					setTimeout(function () {
						window.URL.revokeObjectURL(data);
					}, 100);
					handleSetAlert({
						visible: true,
						variant: 'success',
						message: 'Termo de adesão baixado com sucesso',
						timeout: 5000
					});
				}).catch((error) => {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error.response.data.message,
						timeout: 5000
					});
				})
		}
	}

	return(
		<>
			<Header />
			<Container>
				<Row className="m-3">
					<Col md={6} className="d-flex p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">menu_book</span>
							Contrato
						</h3>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">info</span>
										Informações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingContract && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingContract && <Col md={12}>
											<p><b>Número: </b>{contract?.numero_contrato}</p>
											<p><b>Plano: </b>{contract?.plano}</p>
											<p><b>Valor: </b>R$ {contract?.preco ? parseFloat(contract?.preco).toFixed(2) : ''}</p>
											<p><b>Velocidade de Download: </b>{contract?.download_ativa}</p>
											<p><b>Velodade de Upload: </b>{contract?.upload_ativa}</p>
											<p><b>Data de Adesão: </b>{contract?.data ? formatDate(contract?.data) : ''}</p>
											<p><b>Endereço: </b>{contract?.endereco} n°{contract?.endereco_numero}, {contract?.bairro} - {contract?.cidade}</p>
											<p><b>Status: </b>{contract?.status}</p>
										</Col>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">touch_app</span>
										Ações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingContract && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingContract && <div>
											{contractDetails.scm === 1 && (
													<Row>
														<Col md={8} sm={8} xs={8}>
															<p className="mb-1">Baixar Contrato SCM/SCI</p>
															<p className="color-gray">Documento com os termos contratuais</p>
														</Col>
														<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
															<Button variant="light" onClick={() => window.open("https://netcomet.com.br/Contrato_SCM_SCI_2024.pdf", '_blank')}>Executar</Button>
														</Col>
													</Row>
											)}

											{contractDetails.scm_exclusivo === 1 && (
												<>
													<Row>
														<Col md={12} sm={12} xs={12}>
															<hr />
														</Col>
													</Row>
													<Row>
														<Col md={8} sm={8} xs={8}>
															<p className="mb-1">Baixar Contrato SCM</p>
															<p className="color-gray">Documento com os termos contratuais</p>
														</Col>
														<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
															<Button variant="light" onClick={() => window.open("https://netcomet.com.br/Netcomet_Contrato_SCM.pdf", '_blank')}>Executar</Button>
														</Col>
													</Row>
												</>
											)}

											{contractDetails.stfc === 1 && (
												<>
													<Row>
														<Col md={12} sm={12} xs={12}>
															<hr />
														</Col>
													</Row>
													<Row>
														<Col md={8} sm={8} xs={8}>
															<p className="mb-1">Baixar Contrato STFC</p>
															<p className="color-gray">Documento com os termos contratuais</p>
														</Col>
														<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
															<Button variant="light" onClick={() => window.open("https://netcomet.com.br/Contrato_STFC_2024.pdf", '_blank')}>Executar</Button>
														</Col>
													</Row>
												</>
											)}
											{contract?.desbloqueio === '1' && <>
												<Row>
													<Col md={12} sm={12} xs={12}>
														<hr/>
													</Col>
												</Row>
												<Row>
													<Col md={8} sm={8} xs={8}>
														<p className="mb-1">Informar Pagamento e Desbloquear</p>
														<p className="color-gray">Esta operação irá desbloquear o seu contrato e retornar os seus serviços</p>
													</Col>
													<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
														<Button variant="light" onClick={() => setShowModalUnblock(true)}>Executar</Button>
													</Col>
												</Row>
											</>}
											{contract?.ids_anexo_download_contrato && <>
												{contract?.ids_anexo_download_contrato?.map((link, idx) => (
													<div key={idx}>
														<Row>
															<Col md={12} sm={12} xs={12}>
																<hr/>
															</Col>
														</Row>
														<Row>
															<Col md={8} sm={8} xs={8}>
																<p className="mb-1">Baixar Termo de Adesão {link}</p>
																<p className="color-gray">Documento com os termos de adesão</p>
															</Col>
															<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
																<Button variant="light" onClick={() => {handleContractTerms(link)}}>Executar</Button>
															</Col>
														</Row>
													</div>
												))}
											</>}
											{contract?.links_assinatura && <>
												{contract?.links_assinatura?.map((link, idx) => (
													<div key={idx}>
														<Row>
															<Col md={12} sm={12} xs={12}>
																<hr/>
															</Col>
														</Row>
														<Row>
															<Col md={8} sm={8} xs={8}>
																<p className="mb-1">Assinar Digitalmente</p>
																<p className="color-gray">Documento {idx+1} para assinatura digital</p>
															</Col>
															<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
																<Button variant="light" onClick={() => window.open(link, '_blank')}>Executar</Button>
															</Col>
														</Row>
													</div>
												))}
											</>}
										</div>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>

			<Modal show={showModalUnblock} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Informar Pagamento e Desbloquear
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{loadingModalUnblock && <div className="justify-content-center align-items-center text-center p-2">
							<Spinner animation="border" role="status"/>
							<p className="mt-4">Executando operação, aguarde um momento</p>
						</div>
						}
						{!loadingModalUnblock && <div>
							<Row>
								<Col md={12}>
									{!unblockResponse && <h6>Está operação irá desbloquear o seu contrato retornando os serviços prestados em
										alguns instantes por um período determinado aguardando o processamento do pagamento,
										caso não aconteça no período determinado o contrato será bloqueado assim como os serviços prestados.
										Após utilizar está operação ela ficará indisponível por 30 dias até que possa ser utilizada novamente</h6>}
									{unblockResponse && <Alert variant={unblockResponseStatus ? 'success' : 'danger'} className="d-flex justify-content-center">
										{unblockResponse}
									</Alert>}
								</Col>
							</Row>
						</div>
						}
					</Container>
				</Modal.Body>
				{!loadingModalUnblock &&  <Modal.Footer className="border-top-0">
					<Button variant="light" onClick={() => {unblockResponseReload ? window.location.reload() : setShowModalUnblock(false)}}>Fechar</Button>
					{!unblockResponseReload && <Button variant="primary" onClick={() => handleContractUnblock()}>Desbloquear</Button>}
				</Modal.Footer>
				}
			</Modal>
		</>
	);
}
